(function(){
  function init(){
    var root=document.querySelector('[data-pde-cart]');
    if(!root)return;

    var form=document.getElementById('PdeEquipmentQuoteForm');
    if(!form)return;

    var helpGroup=form.querySelector('[data-pde-help]');
    var helpError=form.querySelector('[data-pde-help-error]');
    var helpInputs=helpGroup?Array.prototype.slice.call(helpGroup.querySelectorAll('input[type="checkbox"]')):[];

    helpInputs.forEach(function(input){
      var label=input.closest('label');
      var sync=function(){
        if(label)label.classList.toggle('is-on',input.checked);
        if(helpInputs.some(function(i){return i.checked;})){
          if(helpError)helpError.hidden=true;
          if(helpGroup)helpGroup.classList.remove('has-error');
        }
      };
      input.addEventListener('change',sync);
      sync();
    });

    var state=form.querySelector('#PdeQuoteState');
    if(state){
      state.addEventListener('blur',function(){state.value=state.value.toUpperCase().trim();});
    }

    var buyLot=root.querySelector('.pde-lot-buy');
    var quoteLot=root.querySelector('.pde-lot-quote');
    var isMixed=!!(buyLot&&quoteLot);

    var keys=[];
    if(quoteLot){
      keys=Array.prototype.slice.call(quoteLot.querySelectorAll('input[name^="updates["]'))
        .map(function(input){
          var m=input.getAttribute('name').match(/^updates\[(.+)\]$/);
          return m?m[1]:null;
        })
        .filter(Boolean);
    }

    var summaryEl=root.querySelector('.pde-split-note ul');
    var summary=summaryEl?Array.prototype.slice.call(summaryEl.querySelectorAll('li')).map(function(li){
      return li.textContent.trim();
    }).join('; '):'';

    var button=form.querySelector('[data-pde-submit]');
    var original=button?button.textContent:'';
    var busy=false;

    function post(url,body){
      return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    }

    function fail(){
      busy=false;
      if(button){button.disabled=false;button.textContent=original;}
      window.location.href='/cart';
    }

    form.addEventListener('submit',function(event){
      form.classList.add('was-validated');

      if(helpInputs.length&&!helpInputs.some(function(i){return i.checked;})){
        event.preventDefault();
        if(helpError)helpError.hidden=false;
        if(helpGroup){
          helpGroup.classList.add('has-error');
          helpGroup.scrollIntoView({behavior:'smooth',block:'center'});
        }
        return;
      }

      if(!form.checkValidity()){
        event.preventDefault();
        form.reportValidity();
        return;
      }

      if(!isMixed||!keys.length)return;

      event.preventDefault();
      if(busy)return;
      busy=true;
      if(button){button.disabled=true;button.textContent='Sending your list...';}

      var data=new FormData(form);
      var attrs={
        'Quote requested for':summary,
        'Quote contact':[data.get('contact[name]'),data.get('contact[email]'),data.get('contact[phone]')].filter(Boolean).join(' / '),
        'Quote practice':data.get('contact[Practice name]')||''
      };

      fetch(form.action,{method:'POST',body:data,headers:{Accept:'text/html'}})
        .catch(function(){})
        .then(function(){
          return post('/cart/update.js',{attributes:attrs}).catch(function(){});
        })
        .then(function(){
          var chain=Promise.resolve();
          keys.forEach(function(key){
            chain=chain.then(function(){
              return post('/cart/change.js',{id:key,quantity:0}).catch(function(){});
            });
          });
          return chain;
        })
        .then(function(){
          return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).catch(function(){return null;});
        })
        .then(function(cart){
          if(cart&&cart.item_count===0){fail();return;}
          window.location.href='/checkout';
        })
        .catch(fail);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
